export const inputFieldCharLimit = 100